'use client'

import ProductCard from '@/components/ProductCard'
import { Product } from '@/lib/db/products'

interface ProductListClientProps {
  products: Product[]
  categorySlug: string
  brands: Array<{ id: string; name: string }>
}

export default function ProductListClient({ products, categorySlug, brands }: ProductListClientProps) {
  if (products.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        Bu kategoriye ait henüz ürün eklenmemiş.
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {products.map((product) => {
        const productBrand = product.brand_id
          ? brands.find((b) => b.id === product.brand_id)
          : null

        return (
          <ProductCard
            key={product.id}
            product={product}
            categorySlug={categorySlug}
            brandName={productBrand?.name || null}
          />
        )
      })}
    </div>
  )
}

